import {
  AutocompleteInput,
  Create,
  Datagrid,
  DateField,
  Edit,
  EditButton,
  Filter,
  List,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  Resource,
  SelectInput,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  minValue,
  required,
} from "react-admin";
import { TRIMMING_UNITS } from "../consts";

const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="article.name" alwaysOn />
    <ReferenceInput label="Project" source="projectId" reference="projects" perPage={500} alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="Process" source="processId" reference="process" filterToQuery={searchText => ({ name: searchText })}>
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="Category" source="process.categoryId" reference="lcaCategory" filterToQuery={searchText => ({ name: searchText })} >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="Origin" source="originId" reference="origins" filterToQuery={searchText => ({ name: searchText })} >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="Transport" source="supplier.transportId" reference="transport" filterToQuery={searchText => ({ name: searchText })} >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  </Filter>
);



// Article Manufacturing components
const ArticleManufacturingList = (props) => {
  return (
    <List {...props} resource="articleProcessManufacturing" filters={Filters(props)}>
      <div style={{ marginTop: '15px' }}>
        <Datagrid rowClick="show">
          <TextField source="id" />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          {/* IT-3172: requiere que el backend embeba `project: { id, name }` en el registro */}
          <TextField source="project.name" label="Project" />
          <TextField source="article.name" label="Article name" />
          <ReferenceField label="Manufacturing" source="manufacturingId" reference="manufacturing">
            <TextField source="name" />
          </ReferenceField>
          <TextField source="supplier.name" label="Supplier" />
          <ReferenceField label="Origin" source="originId" reference="origins">
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField label="Transport" source="transportId" reference="transport">
            <TextField source="name" />
          </ReferenceField>
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowArticleManufacturing = (props) => {
  return (
    <Show {...props} resource="articleProcessManufacturing">
      <SimpleForm>
        <TextField source="id" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
        <TextField source="article.name" label="Article name" />
        <ReferenceField label="Manufacturing" source="manufacturingId" reference="manufacturing">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="supplier.name" label="Supplier" />
        <ReferenceField label="Origin" source="originId" reference="origins">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField label="Transport" source="transportId" reference="transport">
          <TextField source="name" />
        </ReferenceField>
      </SimpleForm>
    </Show>
  );
};

const CreateArticleManufacturing = (props) => {
  return (
    <Create {...props} resource="articleProcessManufacturing">
      <SimpleForm>
        <ReferenceInput label="Article name" source="articleId" reference="articles">
          <AutocompleteInput
            optionText="name"
          />
        </ReferenceInput>
        <ReferenceInput label="Manufacturing" source="manufacturingId" reference="manufacturing">
          <AutocompleteInput
            optionText="name" />
        </ReferenceInput>
        <ReferenceInput label="Supplier" source="supplierId" reference="supplier">
          <AutocompleteInput
            optionText="supplierName"/>
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
};

const EditArticleManufacturing = (props) => {
  return (
    <Edit {...props} resource="articleProcessManufacturing">
      <SimpleForm>
        <ReferenceInput label="Article name" source="articleId" reference="articles">
          <AutocompleteInput
            optionText="name" />
        </ReferenceInput>
        <ReferenceInput label="Manufacturing" source="manufacturingId" reference="manufacturing">
          <AutocompleteInput
            optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Supplier" source="supplierId" reference="supplier">
          <AutocompleteInput
            optionText="supplierName"/>
        </ReferenceInput>
      </SimpleForm>
    </Edit>
  );
};

// Article Finishing components
const ArticleFinishingList = (props) => {
  return (
    <List {...props} resource="articleProcessFinishing" filters={Filters(props)}>
      <div style={{ marginTop: '15px' }}>
        <Datagrid rowClick="show">
          <TextField source="id" />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          {/* IT-3172: requiere que el backend embeba `project: { id, name }` en el registro */}
          <TextField source="project.name" label="Project" />
          <TextField source="article.name" label="Article name" />
          <ReferenceField label="Finishing" source="finishingId" reference="finishing">
            <TextField source="name" />
          </ReferenceField>
          <TextField source="supplier.name" label="Supplier" />
          <ReferenceField label="Origin" source="originId" reference="origins">
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField label="Transport" source="transportId" reference="transport">
            <TextField source="name" />
          </ReferenceField>
          <EditButton />
        </Datagrid>
      </div>
    </List>
  );
};

const ShowArticleFinishing = (props) => {
  return (
    <Show {...props} resource="articleProcessFinishing">
      <SimpleShowLayout>
        <TextField source="id" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
        <TextField source="article.name" label="Article name" />
        <ReferenceField label="Finishing" source="finishingId" reference="finishing">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="supplier.name" label="Supplier" />
        <ReferenceField label="Origin" source="originId" reference="origins">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField label="Transport" source="transportId" reference="transport">
          <TextField source="name" />
        </ReferenceField>
      </SimpleShowLayout>
    </Show>
  );
};

const CreateArticleFinishing = (props) => {
  return (
    <Create {...props} resource="articleProcessFinishing">
      <SimpleForm>
        <ReferenceInput label="Article name" source="articleId" reference="articles">
          <AutocompleteInput
            optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Finishing" source="finishingId" reference="finishing">
          <AutocompleteInput
            optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Supplier" source="supplierId" reference="supplier">
          <AutocompleteInput
            optionText="supplierName"
            required={true} />
        </ReferenceInput>
      </SimpleForm>
    </Create>
  );
};

const EditArticleFinishing = (props) => {
  return (
    <Edit {...props} resource="articleProcessFinishing">
      <SimpleForm>
        <ReferenceInput label="Article name" source="articleId" reference="articles">
          <AutocompleteInput
            optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Finishing" source="finishingId" reference="finishing">
          <AutocompleteInput
            optionText="name"/>
        </ReferenceInput>
        <ReferenceInput label="Supplier" source="supplierId" reference="supplier">
          <AutocompleteInput
            optionText="supplierName"/>
        </ReferenceInput>
      </SimpleForm>
    </Edit>
  );
};

// Article Trimming components
const ArticleTrimmingFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search by article" source="article.name" alwaysOn />
    <ReferenceInput label="Project" source="projectId" reference="projects" perPage={500} alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="Trimming" source="trimmingId" reference="trimming" filterToQuery={searchText => ({ name: searchText })}>
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const ArticleTrimmingList = (props) => (
  <List {...props} resource="articleProcessTrimming" filters={<ArticleTrimmingFilters />}>
    <div style={{ marginTop: '15px' }}>
      <Datagrid rowClick="show">
        <TextField source="id" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
        {/* IT-3172: requiere que el backend embeba `project: { id, name }` en el registro */}
        <TextField source="project.name" label="Project" />
        <TextField source="article.name" label="Article name" />
        {/* El backend no embebe `trimming`; resolvemos el nombre desde trimmingId */}
        <ReferenceField label="Trimming" source="trimmingId" reference="trimming" link={false}>
          <TextField source="name" />
        </ReferenceField>
        <NumberField source="quantity" label="Quantity" />
        <TextField source="unit" label="Unit" />
        <EditButton />
      </Datagrid>
    </div>
  </List>
);

const ShowArticleTrimming = (props) => (
  <Show {...props} resource="articleProcessTrimming">
    <SimpleShowLayout>
      <TextField source="id" />
      <DateField source="createdAt" label="Creation date" />
      <DateField source="updatedAt" label="Update date" />
      <TextField source="article.name" label="Article name" />
      <ReferenceField label="Trimming" source="trimmingId" reference="trimming" link={false}>
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="quantity" label="Quantity" />
      <TextField source="unit" label="Unit" />
    </SimpleShowLayout>
  </Show>
);

const CreateArticleTrimming = (props) => (
  <Create {...props} resource="articleProcessTrimming">
    <SimpleForm>
      <ReferenceInput label="Article" source="articleId" reference="articles" filterToQuery={searchText => ({ name: searchText })} validate={[required()]}>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput label="Trimming" source="trimmingId" reference="trimming" filterToQuery={searchText => ({ name: searchText })} validate={[required()]}>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <NumberInput source="quantity" label="Quantity" validate={[required(), minValue(0)]} />
      <SelectInput source="unit" label="Unit" choices={TRIMMING_UNITS} validate={[required()]} />
    </SimpleForm>
  </Create>
);

const EditArticleTrimming = (props) => (
  <Edit {...props} resource="articleProcessTrimming">
    <SimpleForm>
      <ReferenceInput label="Article" source="articleId" reference="articles" filterToQuery={searchText => ({ name: searchText })} validate={[required()]}>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <ReferenceInput label="Trimming" source="trimmingId" reference="trimming" filterToQuery={searchText => ({ name: searchText })} validate={[required()]}>
        <AutocompleteInput optionText="name" />
      </ReferenceInput>
      <NumberInput source="quantity" label="Quantity" validate={[required(), minValue(0)]} />
      <SelectInput source="unit" label="Unit" choices={TRIMMING_UNITS} validate={[required()]} />
    </SimpleForm>
  </Edit>
);

// Original Article Process resource (keeping for compatibility)
const articleProcessResource = () => <Resource
  name="articleProcess"
  options={{ label: 'Article process', menuGroup: 'Articles' }}
/>;

// New Article Manufacturing resource
const articleManufacturingResource = () => <Resource
  name="articleProcessManufacturing"
  options={{ label: 'Article manufacturing', menuGroup: 'Article Process Sub' }}
  list={ArticleManufacturingList}
  create={CreateArticleManufacturing}
  edit={EditArticleManufacturing}
  show={ShowArticleManufacturing}
  path="articleManufacturing" />;

// New Article Finishing resource
const articleFinishingResource = () => <Resource
  name="articleProcessFinishing"
  options={{ label: 'Article finishing', menuGroup: 'Article Process Sub' }}
  list={ArticleFinishingList}
  create={CreateArticleFinishing}
  edit={EditArticleFinishing}
  show={ShowArticleFinishing}
  path="articleFinishing" />;

// New Article Trimming resource
const articleTrimmingResource = () => <Resource
  name="articleProcessTrimming"
  options={{ label: 'Article trimming', menuGroup: 'Article Process Sub' }}
  list={ArticleTrimmingList}
  create={CreateArticleTrimming}
  edit={EditArticleTrimming}
  show={ShowArticleTrimming}
  path="articleTrimming" />;

export {
  articleFinishingResource, articleManufacturingResource, articleProcessResource, articleTrimmingResource
};

export default articleProcessResource;
